import React from "react";
import { useSelector } from "react-redux";
import PayRollTable from "../../../../components/Tables/PayRollTable";
import { useTheme } from "../../../../Themecontext/Themecontext";

export default function Loan() {
  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { EmployeeLoanDtldata } = useSelector((state) => state.PayRollSlice);
  console.log(EmployeeLoanDtldata);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWPAYROLL");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWPAYROLLDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;
  const getRows =
    EmployeeLoanDtldata?.Data?.length > 0
      ? EmployeeLoanDtldata.Data.map((label, index) => ({
          id: index + 1,
          FinYear: label?.FinYear || "",
          Jan: label?.Jan || 0,
          Feb: label?.Feb || 0,
          Mar: label?.Mar || 0,
          Apr: label?.Apr || 0,
          May: label?.May || 0,
          Jun: label?.Jun || 0,
          Jul: label?.Jul || 0,
          Aug: label?.Aug || 0,
          Sep: label?.Sep || 0,
          Oct: label?.Oct || 0,
          Nov: label?.Nov || 0,
          Dec: label?.Dec || 0,
          RowType: label?.RowType || "",
          TotalInstallment: label?.TotalInstallment || 0,
          NoOfInstallment: label?.NoOfInstallment || 0,
        }))
      : [];
  const getColumns = [
    { key: "id", label: "ID" },
    { key: "RowType", label: "Row Type" },
    { key: "FinYear", label: "Financial Year" },
    { key: "TotalInstallment", label: "Total Installment" },
    { key: "NoOfInstallment", label: "No Of Installment" },
    { key: "Apr", label: "Apr" },
    { key: "May", label: "May" },
    { key: "Jun", label: "Jun" },
    { key: "Jul", label: "Jul" },
    { key: "Aug", label: "Aug" },
    { key: "Sep", label: "Sep" },
    { key: "Oct", label: "Oct" },
    { key: "Nov", label: "Nov" },
    { key: "Dec", label: "Dec" },
    { key: "Jan", label: "Jan" },
    { key: "Feb", label: "Feb" },
    { key: "Mar", label: "Mar" },
  ];

  return (
    <div
      style={{
        background:
          isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
      }}
    >
      <div
        style={{
          marginTop: "25px",
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
        }}
      >
        <div
          style={{
            padding: "14px",
            background:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7,
            color: "#fff",
            fontWeight: "600",
            fontSize: "18px",
            margin: 0,
            letterSpacing: "1px",
          }}
        >
          LOAN
        </div>

        <PayRollTable columns={getColumns} data={getRows} showSearch={true} />
      </div>
    </div>
  );
}
